export const periodMap = {
  1: "year",
  2: "quarter",
  3: "month",
  4: "week",
  5: "day",
  6: "hour",
};

export const rangeMap = {
  1: "current",
  2: "previous",
  3: "custom",
};
